import { groupRowsForReview } from '../../../utils/reviewRowGrouping';
import {
  buildNaturalCaptureLongNoteRows,
} from './importLogsLongNoteParsing';
import {
  buildNaturalCaptureSchoolRows,
} from './importLogsSchoolAdapter';
import {
  normalizeImportedFileReviewRows,
} from './importLogsReviewNormalization';
import { detectNaturalCaptureInputShape } from './naturalCaptureChunkingCore';
import { runNaturalCaptureImportedDocAdapter } from './naturalCaptureImportedDocAdapter';

export const buildImportedFileTextReviewRows = ({
  text = '',
  defaultDate = new Date(),
  childName = null,
  parserMode = 'file_import_text',
  sourceMode = 'docx_xlsx',
  inputMode = 'file_import',
  rawText = '',
} = {}) => (
  runNaturalCaptureImportedDocAdapter({
    text,
    shapeHint: detectNaturalCaptureInputShape(text, {
      adapterMode: 'imported_file_text',
      parserMode,
      sourceMode,
      inputMode,
    }),
    adapterMode: 'imported_file_text',
    source: sourceMode,
    childId: childName,
    selectedDate: defaultDate,
    timezone: '',
    options: {
      defaultDate,
      childName,
      parserMode,
      sourceMode,
      inputMode,
      rawText,
    },
  }, {
    defaultDate,
    childName,
    parserMode,
    sourceMode,
    inputMode,
    rawText,
  }, {
    buildNaturalCaptureLongNoteRows,
    buildNaturalCaptureSchoolRows,
    groupRowsForReview,
    normalizeImportedFileReviewRows,
  })
);

export const runImportedFileTextAdapter = (adapterInput = {}, {
  defaultDate = new Date(),
  childName = null,
  parserMode = 'file_import_text',
  sourceMode = 'docx_xlsx',
  inputMode = 'file_import',
  rawText = '',
} = {}) => buildImportedFileTextReviewRows({
  text: adapterInput.text,
  defaultDate,
  childName,
  parserMode,
  sourceMode,
  inputMode,
  rawText,
});
